import React from "react";
import Button from "./index.js";

const DangerButton = (props) => (
  <Button buttonType="button-danger" {...props} />
);
export default DangerButton;
